import React, { useState } from 'react';
import {  FaBox, FaBed, FaTshirt, FaTv } from 'react-icons/fa';
import { Link } from 'react-router-dom';

function StudentRemovalServices() {
  const [quote, setQuote] = useState("");

  const services = [
    { name: "Wardrobe", icon: <FaTshirt className="w-16 h-16 text-gray-600" /> },
    { name: "Flatpacks", icon: <FaBox className="w-16 h-16 text-gray-600" /> },
    { name: "Furniture", icon: <FaBed className="w-16 h-16 text-gray-600" /> },
    { name: "Home Appliances", icon: <FaBox className="w-16 h-16 text-gray-600" /> },
    { name: "TV / Entertainment Unit", icon: <FaTv className="w-16 h-16 text-gray-600" /> },
  ];

  const handleQuoteChange = (event) => {
    setQuote(event.target.value);
  };

  const handleSubmitQuote = () => {
    alert(`Your free quote has been submitted: ${quote}`);
  };

  return (
    <div className=''>
      {/* Hero Section */}
      <div
        className="relative bg-cover bg-center h-[400px] md:h-[600px]"
        style={{ backgroundImage: "url('images/studentremoval.png')" }}
      >
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 flex flex-col items-center justify-center text-center h-full text-white">
          <h1 className="text-4xl md:text-6xl xl:text-7xl font-semibold">Easy & Reliable Student Removal Services</h1>
          <p className="text-lg mt-4">We make your university move stress-free and affordable. Get your free quote now!</p>
        </div>
      </div>

      {/* Service Overview Section */}
      <section id="service-overview" className="py-16 px-3 bg-white text-black">
        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-thin">What We Do</h2>
          <p className="text-lg max-w-4xl mx-auto mt-4 font-thin">
            We get regular calls from university & college students asking if we can help with moving their things. We offer a
            same-day collection and delivery service. Whether it's boxes, bags, or large furniture, we’ve got you covered.
          </p>
        </div>

        {/* Services List */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8 mt-12 text-center">
          {services.map((service, index) => (
            <div key={index} className="flex flex-col items-center">
              {service.icon}
              <h3 className="text-xl font-thin mt-4">{service.name}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* Moving Large Items */}
      <section id="large-items" className="py-2 px-2 bg-white text-black">
        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-thin">We Handle Large Items</h2>
          <p className="text-lg max-w-4xl mx-auto font-thin mt-4">
            We specialize in handling large items like wardrobes, furniture, and home appliances. Trust us to take care of your valuable
            belongings with our reliable and affordable service.
          </p>
        </div>
      </section>

      {/* Same Day Pickup & Delivery */}
      <section id="same-day" className="py-16 px-2 bg-white text-black">
        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-thin">Same-Day Pickup and Delivery</h2>
          <p className="text-lg max-w-4xl mx-auto mt-4 font-thin">
            With access to over 3000 drivers, we guarantee a pickup within 60 minutes from quote approval. Your items will be delivered on the same day.
          </p>
        </div>
      </section>

      {/* Request a Free Quote */}
      <section id="quote" className="py-16 px-2 bg-white text-black">
        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-thin">Get Your Free Quote</h2>
          <p className="text-lg max-w-4xl mx-auto mt-4 font-thin">
            Moving to university can be stressful, but we’re here to help. Fill out the details below for a free quote.
          </p>
          <div className='flex justify-center'>
      <Link to='/contactus'>
    <button className="mt-4 px-8 py-3 bg-slate-900 text-white  hover:bg-gray-200 transition-colors">  ContactUs</button></Link>
    </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section id="faq" className="py-16 bg-white text-black">
        <div className="text-center">
          <h2 className="text-2xl md:text-4xl font-thin">FAQ`s</h2>
          <div className="space-y-6 mt-8 max-w-4xl mx-auto">
            <div>
              <h3 className="text-2xl font-thin">How does the removal service work?</h3>
              <p className="text-base md:text-xl mt-2 font-thin">
                You simply provide us with the details of the items you need moved, and we’ll give you a free quote. Once you approve, we’ll
                collect and deliver your belongings on the same day.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-thin">Do you handle large furniture items?</h3>
              <p className="text-base md:text-xl mt-2 font-thin">
                Yes! We can move large items like wardrobes, furniture, home appliances, and more. Let us take care of your valuable
                belongings.
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-thin">How fast can you collect my items?</h3>
              <p className="text-base md:text-xl mt-2 font-thin">
                We can collect your items within 60 minutes of quote approval and deliver them the same day, thanks to our network of over
                3000 drivers.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default StudentRemovalServices;
